// Fonctionnalités d'un pack d'abonnement, mêmes codes que le back-end
// (src/abonnement/pack-features.ts). Le super admin coche celles de chaque pack.
export const PACK_FEATURE = {
  CLAIMS: 'CLAIMS',
  RESERVATIONS: 'RESERVATIONS',
  STAFF_MANAGEMENT: 'STAFF_MANAGEMENT',
  STAFF_REVIEWS: 'STAFF_REVIEWS',
  STAFF_AI_REPORTS: 'STAFF_AI_REPORTS'
};
